import { render, staticRenderFns } from "./RecPointStatsDialog.vue?vue&type=template&id=1423d9b6&scoped=true"
import script from "./RecPointStatsDialog.vue?vue&type=script&lang=js"
export * from "./RecPointStatsDialog.vue?vue&type=script&lang=js"
import style0 from "./RecPointStatsDialog.vue?vue&type=style&index=0&id=1423d9b6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1423d9b6",
  null
  
)

export default component.exports